import { Order_By, useGetCategoryBySlugQuery } from '@/generated/graphql';
import format from '@/utils/format';
import RightTableThreeItem from '../Shared/RightTableThreeItem';
import { IPostCardProps } from '@/interfaces/card';

interface IRelatedCategoryProps {
  fullSlug?: string | null;
}

const RelatedCategory = ({ fullSlug }: IRelatedCategoryProps) => {
  const { data } = useGetCategoryBySlugQuery({
    variables: {
      where: {
        path_full_slug: {
          full_slug: {
            _eq: fullSlug,
          },
        },
      },
      allPostsLimit: 3,
      allPostsOrderBy: [{ published_at: Order_By.DescNullsLast }],
      allPostsWhere: {
        published_at: {
          _is_null: false,
          _lte: 'now()',
        },
      },
      allPostsChildLimit: 3,
      allPostsChildOrderBy: {
        published_at: Order_By.Desc,
      },
    },
  });

  return (
    <div className="flex flex-col gap-4">
      {data?.categories?.[0]?.relatedCategories
        ?.slice(0, 2)
        ?.map((item, index) => {
          return (
            <RightTableThreeItem
              key={index}
              category={item?.category}
              data={format.formatDataPost(
                item?.category?.allPosts as IPostCardProps[],
              )}
            />
          );
        })}
    </div>
  );
};

export default RelatedCategory;
